import { useEffect } from "react";
import { appStore } from "src/stores/app.store.ts";

export const useDebugQueries = () => {
  const enabled = location.search.includes("start-debug-queries");
  const disabled = location.search.includes("stop-debug-queries");
  useEffect(() => {
    if (enabled) {
      appStore.setDebugDbQueries(true);
      /* eslint-disable no-console */
      console.log("Debug queries enabled");
    }
    if (disabled) {
      appStore.setDebugDbQueries(false);
      /* eslint-disable no-console */
      console.log("Debug queries disabled");
    }
  }, [enabled, disabled]);
};
